// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { IconButton, IconButtonProps } from '@material-ui/core';

import { RiPencilFill as Edit } from '@remixicon/react';

/** @deprecated Use EditButtonBui instead. */
export const EditButton = (props: IconButtonProps) => {
  return (
    <IconButton
      size={props.size}
      aria-label="Edit"
      data-track-id="button.edit"
      data-track-action="open-dialog"
      {...props}
    >
      <Edit size={props.size === 'small' ? 20 : 24} />
    </IconButton>
  );
};
